<div class="badge-block {{ badge.color }} {{ badge.type }}" *ngIf="!!badge && !!badge?.text">
  <span class="badge-block__text">{{ badge.text | translate | uppercase }}</span>
</div>
